<template>
  <div class="fwf_loading no-select">
    <div class="fwf_loader">
      <img :src="pluginURL+'images/spinner.svg'">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: {
  },

  directives: {
  },

  props: {
  },

  data () {
    return {
      pluginURL: window.wpApiSettings.pluginURL
    }
  },

  methods: {
  },

  watch: {
  },

  computed: {
    ...mapState([
      'appOptions'
    ])
  }

}
</script>

<style>

.fwf_zone_loading{
  position: relative;
}

.fwf_zone_loading .fwf_loading{
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background:rgba(255,255,255,0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 90;
}

.fwf_loading .fwf_loader{
  position: absolute;
  top: 20vh;
  left:50%;
  transform: translateX(-50%);
  background:#FFF;
  border-radius: 10px;
  overflow: hidden;
  border: 2px solid var(--couleur1);
}

.fwf_loading .fwf_loader img{
  width: 50px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/loading.vue